export const SET_LAYOUT = 'SET_LAYOUT';
